import cx from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useTableStore from '@/storybook/components/Table/store/useTableStore';
import styles from './PageInfo.module.scss';

interface PageInfoProps {
  tableId: string;
  className?: string;
  extended?: boolean;
  totalRecords?: number;
}

const PageInfo = ({ tableId, className, extended = true, totalRecords }: PageInfoProps) => {
  const { t } = useTranslation();
  const tableState = useTableStore(state => state.state[tableId]);

  if (!tableState) return null;

  const {
    pagination: { pageIndex, pageSize },
    totalRecords: storedTotalRecords,
    loading,
  } = tableState;
  const resolvedTotalRecords = totalRecords ?? storedTotalRecords;

  const from = pageIndex * pageSize + 1;
  const to = Math.min(from + pageSize - 1, resolvedTotalRecords);

  const getResultText = () => {
    if (loading) {
      return t('global.table.loading');
    }
    if (resolvedTotalRecords <= 0) {
      return t('global.table.noResults');
    }
    if (extended) {
      return t('global.table.results', { total: resolvedTotalRecords, from, to });
    }
    return t('global.table.resultsShort', { total: resolvedTotalRecords });
  };

  return <div className={cx(className, styles.pageInfo)}>{getResultText()}</div>;
};

export default PageInfo;
